// const rolesJson = JSON.parse(document.querySelector('meta[name="roles"]').getAttribute("content"));
const rolesJson = [];
let roles = {};

rolesJson.forEach((role) => {
    roles[role.slug] = role.id;
});

import store from './../../store';

export default {
    methods: {
        hasRole(role) {
            if (store.getters['auth/isLoggedIn']) {
                if (roles.hasOwnProperty(role)) {
                    let roleId = roles[role];
                    let authenticatedUser = store.getters['auth/getUser'];
                    return authenticatedUser.role_ids.indexOf(roleId) > -1;
                }
            }

            return false;
        },
        hasMinRole(role) {
            if (store.getters['auth/isLoggedIn']) {
                if (roles.hasOwnProperty(role)) {
                    let roleId = roles[role];
                    let authenticatedUser = store.getters['auth/getUser'];

                    for (let i = 0; i < authenticatedUser.role_ids.length; i++) {
                        let userRoleId = authenticatedUser.role_ids[i];
                        if (userRoleId >= roleId) {
                            return true;
                        }
                    }
                }
            }

            return false;
        },
        hasMaxRole(role) {
            if (store.getters['auth/isLoggedIn']) {
                if (roles.hasOwnProperty(role)) {
                    let roleId = roles[role];
                    let authenticatedUser = store.getters['auth/getUser'];

                    for (let i = 0; i < authenticatedUser.role_ids.length; i++) {
                        let userRoleId = authenticatedUser.role_ids[i];
                        if (userRoleId <= roleId) {
                            return true;
                        }
                    }
                }
            }

            return false;
        },
        belowRole(role) {
            if (store.getters['auth/isLoggedIn']) {
                if (roles.hasOwnProperty(role)) {
                    let roleId = roles[role];
                    let authenticatedUser = store.getters['auth/getUser'];

                    for (let i = 0; i < authenticatedUser.role_ids.length; i++) {
                        let userRoleId = authenticatedUser.role_ids[i];

                        if (userRoleId >= roleId) {
                            return false;
                        }
                    }
                    return true;
                }
            }

            return false;
        },
        aboveRole(role) {
            if (store.getters['auth/isLoggedIn']) {
                if (roles.hasOwnProperty(role)) {
                    let roleId = roles[role];
                    let authenticatedUser = store.getters['auth/getUser'];

                    for (let i = 0; i < authenticatedUser.role_ids.length; i++) {
                        let userRoleId = authenticatedUser.role_ids[i];

                        if (userRoleId <= roleId) {
                            return false;
                        }
                    }
                    return true;
                }
            }

            return false;
        },
        userHasMinRole(user, role) {
            if (roles.hasOwnProperty(role)) {
                let roleId = roles[role];

                if (typeof user.roles !== 'undefined') {
                    for (let i = 0; i < user.roles.length; i++) {
                        let userRoleId = user.roles[i].id;
                        if (userRoleId >= roleId) {
                            return true;
                        }
                    }
                }
            }

            return false;
        },
        userHasRole(user, role) {
            if (roles.hasOwnProperty(role)) {
                let roleId = roles[role];

                if (typeof user.roles !== 'undefined') {
                    return authenticatedUser.role_ids.indexOf(roleId) > -1;
                }
            }

            return false;
        }
    }
};
